module.exports = __webpack_public_path__ + "static/media/SofiaProBold.c04780b6.eot";